export var routingActionCreator = function (route, alternativeRoute) {
    return {
        type: route,
        backTo: alternativeRoute || null
    };
};
